import get from 'lodash/get';
import has from 'lodash/has';
import orderBy from 'lodash/orderBy';
import { createSelector } from 'reselect';

import { entityTypes } from 'pages/store/actions/defaults';
import { listNormalizer, normalizer } from 'pages/store/schema';

const getEntity = (entity) => (state) => get(state, `entities.${entity}`, {});
const getById = (entity) => (state) => get(state, `byId.${entity}`, []);

export const getValues = (entity) =>
  createSelector([getEntity(entity), getById(entity)], (values, byId) => {
    if (has(normalizer, entity) || has(listNormalizer, entity)) {
      return byId.reduce((acc, id) => {
        acc.push(values[id]);
        return acc;
      }, []);
    }
    return values;
  });

export const getOrderedValues = (iteratees, orders) => (entity) =>
  createSelector([getValues(entity)], (values) => orderBy(values, iteratees, orders));

export const getValue = (entity, entityId) => (state) =>
  get(state, `entities.${entity}.${entityId}`);
export const getMeta =
  ({ entity, list }) =>
  (state) =>
    get(state, `meta.${entity}.${list ? entityTypes.LIST : entityTypes.SINGLE}`, {});
export const getLinks =
  ({ entity, list }) =>
  (state) =>
    get(state, `links.${entity}.${list ? entityTypes.LIST : entityTypes.SINGLE}`, {});
export const getProcessing =
  ({ entity, list = false, actionType }) =>
  (state) =>
    get(
      state,
      `processing.${entity}.${list ? entityTypes.LIST : entityTypes.SINGLE}.${actionType}.status`
    );
export const getErrors =
  ({ entity, list = false, actionType }) =>
  (state) =>
    get(
      state,
      `processing.${entity}.${list ? entityTypes.LIST : entityTypes.SINGLE}.${actionType}.errors`
    );
